
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf.js";
import "pdfjs-dist/legacy/build/pdf.worker.entry.js";
import { getBlob, ref } from "firebase/storage";
import { storage } from "../Config/firebase";
import "./RelatorioTracaoPrint.css";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";

const dataBR = v =>
  v && v.includes("-") ? v.split("-").reverse().join("/") : v || "-";

const texto = v => v || "-";

async function aguardarImagensRelatorio() {
  const imagens = Array.from(document.querySelectorAll(".relatorio-tracao img"));

  await Promise.all(
    imagens.map((img) => {
      if (img.complete && img.naturalWidth > 0) {
        return img.decode ? img.decode().catch(() => {}) : Promise.resolve();
      }

      return new Promise((resolve) => {
        img.addEventListener("load", resolve, { once: true });
        img.addEventListener("error", resolve, { once: true });
      });
    })
  );
}

async function imprimirRelatorioTracao() {
  await aguardarImagensRelatorio();
  window.setTimeout(() => window.print(), 100);
}

const opcoes = {
  substrato: {
    blocoCeramico: "Bloco de vedação - cerâmico",
    estruturaConcreto: "Estrutura de concreto",
    blocoConcreto: "Bloco de vedação - concreto",
    outros: "Outros",
  },
  argamassa: {
    cimento: "Cimento",
    mista: "Mista",
    industrializada: "Industrializada",
    naoInformado: "Não informado",
  },
  tipoAplicacao: {
    manual: "Manual",
    mecanica: "Mecânica",
    naoInformado: "Não informado",
  },
};

const formasRuptura = [
  { key: "substrato", label: "Substrato" },
  { key: "substratoChapisco", label: "Substrato/ Chapisco" },
  { key: "chapisco", label: "Chapisco" },
  { key: "chapiscoArgamassa", label: "Chapisco/ Argamassa" },
  { key: "argamassa", label: "Argamassa" },
  { key: "argamassaCola", label: "Argamassa/ Cola" },
  { key: "colaPastilha", label: "Cola/ Pastilha" },
];

const CONFIGURACOES_POR_TIPO = {
  A: {
    titulo:
      "Relatório de ensaio - Determinação da resistência de aderência à tração de revestimentos de argamassa",
    metodologia:
      "O ensaio segue as prescrições das normas da ABNT:\n" +
      "√ ABNT NBR 13749 - Revestimento de paredes e tetos de argamassas inorgânicas - Especificação.\n" +
      "√ ABNT NBR 13528 - Revestimento de paredes de argamassas inorgânicas - Determinação da resistência de aderência à tração.",
  },
  B: {
    titulo:
      "Relatório de ensaio - Determinação da resistência de aderência à tração de paredes internas com placas cerâmicas e com utilização de argamassa colante",
    metodologia:
      "O ensaio segue as prescrições das normas da ABNT:\n" +
      "√ ABNT NBR 13754 - Revestimento de paredes internas com placas cerâmicas e com utilização de argamassa colante - procedimento - Anexo A - Determinação da resistência de aderência de revestimentos cerâmicos assentados com argamassa colante.",
  },
  C: {
    titulo:
      "Relatório de ensaio - Determinação da resistência de aderência à tração de paredes externas com utilização de argamassa colante",
    metodologia:
      "O ensaio segue as prescrições das normas da ABNT:\n" +
      "√ ABNT NBR 13755 - Revestimentos cerâmicos de fachadas e paredes externas com utilização de argamassa colante — Projeto, execução, inspeção e aceitação — Procedimento,",
  },
  D: {
    titulo:
      "Relatório de ensaio - Revestimento de piso interno ou externo com placas cerâmicas e com utilização de argamassa colante - Procedimento",
    metodologia:
      "O ensaio segue as prescrições das normas da ABNT:\n" +
      "√ ABNT NBR 13753 - Revestimento de paredes internas com placas cerâmicas e com utilização de argamassa colante - procedimento - Anexo A - Determinação da resistência de aderência de revestimentos cerâmicos assentados com argamassa colante.",
  },
};

const normalizarTipoEnsaio = (tipo) => {
  if (["A", "B", "C", "D"].includes(tipo)) return tipo;
  return tipo === "placaQuadrada" ? "B" : "A";
};

const usaPlacaQuadrada = (tipo) => normalizarTipoEnsaio(tipo) !== "A";

const ACEITACAO_PADRAO =
  "O revestimento deve ser aceito se de cada grupo de 12 ensaios realizados, com idade igual ou superior a 28 dias, pelo menos oito valores forem iguais ou superiores aos indicados na tabela abaixo:";

const ACEITACAO_TIPO_D =
  "Para os 12 corpos de prova, considerados como dois grupos de seis determinações, o ensaio será aceito quando, em cada grupo, pelo menos quatro valores forem iguais ou superiores a 0,30 MPa, após a cura de 28 dias da argamassa colante utilizada no assentamento.";

const TEXTO_RESUMO_QUANTIDADE_TIPO_D_PADRAO = "Valores acima de 0,30 MPa";
const TEXTO_CRITERIO_RESUMO_TIPO_D_PADRAO =
  "Critério: mínimo de 8 resultados ≥ 0,30 MPa em cada grupo de 12";

const TABELA_ACEITACAO_PADRAO = [
  { local: "Parede interna", acabamento: "Pintura ou base para reboco", ra: "≥ 0,20" },
  { local: "Parede interna", acabamento: "Cerâmica ou laminado", ra: "≥ 0,30" },
  { local: "Parede externa", acabamento: "Pintura, reboco ou cerâmica", ra: "≥ 0,30" },
  { local: "Teto", acabamento: "-", ra: "≥ 0,20" },
];

const TABELA_ACEITACAO_TIPO_D = [
  { local: "Piso interno ou externo", acabamento: "Placas cerâmicas", ra: "≥ 0,30" },
];

const tabelaAceitacaoIgual = (tabelaA, tabelaB) =>
  JSON.stringify(tabelaA) === JSON.stringify(tabelaB);

function valor(v) {
  if (v === 0 || v === "0") return "0";
  if (v === null || v === undefined || v === "") return "-";
  return String(v).replace(".", ",");
}

function numeroOuNulo(v) {
  if (v === null || v === undefined || ["", "-"].includes(String(v).trim())) return null;
  const n = Number(String(v).replace(",", "."));
  return Number.isFinite(n) ? n : null;
}

function decimal(v, casas) {
  const numero = numeroOuNulo(v);
  return numero === null ? "-" : numero.toFixed(casas).replace(".", ",");
}

function areaCalculada(cp, tipoEnsaio = "A") {
  const d1 = numeroOuNulo(cp?.d1);
  const d2 = numeroOuNulo(cp?.d2);

  if (d1 !== null && d2 !== null) {
    if (usaPlacaQuadrada(tipoEnsaio)) return d1 * d2;

    const diametroMedio = (d1 + d2) / 2;
    return (Math.PI * diametroMedio * diametroMedio) / 4;
  }

  return numeroOuNulo(cp?.area);
}

function tensaoCalculada(cp, tipoEnsaio = "A") {
  const carga = numeroOuNulo(cp?.cargaRuptura);
  const area = areaCalculada(cp, tipoEnsaio);

  if (carga !== null && area !== null && area > 0) {
    return (carga * 9.80665) / area;
  }

  return numeroOuNulo(cp?.tensao);
}

function Secao({ numero, titulo, children }) {
  return (
    <section>
      <h2>
        {numero}. {titulo}
      </h2>
      {children}
    </section>
  );
}

function Cabecalho({ e }) {
  const tipoEnsaio = normalizarTipoEnsaio(e.tipoEnsaio);
  const configuracao = CONFIGURACOES_POR_TIPO[tipoEnsaio];

  return (
    <>
      <div className="cabecalho-quadro">
        <header>
          <div className="cabecalho-logo">
            <LogoRelatorio alt="Logo da empresa"  />
          </div>

          <div className="cabecalho-titulos">
            <strong>SISTEMA DE GESTÃO DA QUALIDADE</strong>
            <span>{configuracao.titulo}</span>
          </div>

          <aside>
            <span>
              RQ 2.2.16{tipoEnsaio === "A" ? " - A" : ` ${tipoEnsaio}`}
            </span>
            <span>REVISÃO 00</span>
            <span>20/09/2025</span>
          </aside>
        </header>

        <div className="linha-codigo">
          <span>
            <b>DATA</b>
            <em>{dataBR(e.dataRelatorio || e.dataEnsaio)}</em>
          </span>
          <span>
            <b>CÓDIGO:</b> {e.codigo}
          </span>
        </div>
      </div>

      <div className="separador-cabecalho" />

      <div className="dados">
        <p>
          <b>EMPRESA SOLICITANTE:</b>
          <span>{texto(e.cliente)}</span>
        </p>
        <p>
          <b>EMPREENDIMENTO:</b>
          <span>{texto(e.obra)}</span>
        </p>
        <p>
          <b>ENDEREÇO:</b>
          <span>{texto(e.endereco)}</span>
        </p>
      </div>
    </>
  );
}

function Check({ ativo, label }) {
  return (
    <span className="check">
      <i>{ativo ? "✓" : ""}</i>
      {label}
    </span>
  );
}

function TextoEmLinhas({ conteudo }) {
  return String(conteudo || "")
    .split(/\r?\n/)
    .map((linha, index) => <p key={index}>{linha || "\u00a0"}</p>);
}

function QuadroUmidade({ e }) {
  return (
    <>
      <h3>Quadro 2 - Ensaio de Umidade do revestimento.</h3>

      <table className="umidade">
        <thead>
          <tr>
            <th>Nº</th>
            <th>Mi (g)</th>
            <th>Mu (g)</th>
            <th>Ms (g)</th>
            <th>W (%)</th>
          </tr>
        </thead>
        <tbody>
          {[0, 1, 2].map((_, i) => {
            const u = e.umidade?.[i] || {};
            const miInformado = numeroOuNulo(u.mi);
            const mi = miInformado ?? 0;
            const mu = numeroOuNulo(u.mu);
            const ms = numeroOuNulo(u.ms);
            const w =
              mu !== null && ms !== null && ms !== 0
                ? ((mu - mi - ms) / ms) * 100
                : null;

            return (
              <tr key={i}>
                <td>{i + 1}</td>
                <td>{decimal(u.mi, 2)}</td>
                <td>{decimal(u.mu, 2)}</td>
                <td>{decimal(u.ms, 2)}</td>
                <td>{w !== null ? w.toFixed(1).replace(".", ",") : "-"}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="legenda">
        <b>LEGENDA:</b>
        <br />
        Mu (g) é a massa úmida do testemunho + massa do recipiente
        <br />
        Mi (g) é a massa do recipiente
        <br />
        Ms (g) é a massa seca do corpo de prova
        <br />
        W (%) é a umidade do revestimento = &#123;[(Mu-Mi) - Ms]/Ms&#125;*100
      </div>
    </>
  );
}

function Rodape() {
  return (
    <footer className="rodape-relatorio">
      <div className="rodape-restrito">
        <div className="linha-rodape" />
        <div>
          DOCUMENTO PARA USO RESTRITO. REPRODUÇÃO/CÓPIA PROIBIDA SEM
          AUTORIZAÇÃO DA EMPRESA
        </div>
      </div>
    </footer>
  );
}

function Observacoes({ e, numero = 6 }) {
  const celula = e.certificadoCelulaCarga;
  const identificacaoCelula = [
    celula?.equipamentoNome,
    celula?.equipamentoDescricao,
  ]
    .filter(Boolean)
    .join(" - ");

  return (
    <section className="observacoes-tracao">
      <h2>{numero}. OBSERVAÇÕES</h2>

      <div className="observacoes-conteudo">
        <div className="observacoes-texto">
          {celula && (
            <p>
              <b>Anexo:</b> Certificado de Calibração célula de carga
            </p>
          )}
          {String(e.equipamentoCorte || "").trim() && (
            <p>Equipamento de corte - {e.equipamentoCorte}</p>
          )}
          {String(e.colaUtilizada || "").trim() && (
            <p>Cola utilizada: {e.colaUtilizada}</p>
          )}
          {celula && (
            <p>
              Célula de carga a tração: {identificacaoCelula || "Equipamento não identificado"}
              {celula.numeroCertificado
                ? ` - Certificado nº ${celula.numeroCertificado}`
                : ""}
            </p>
          )}
          <TextoEmLinhas conteudo={e.observacoes} />
        </div>

        <div className="assinatura-tracao">
          <img src="/Images/assinaturaLeal.png" alt="Assinatura" />
          <div className="linha-assinatura" />
          <p>José Carlos Lemes Leal</p>
          <p>Eng. Civil Esp. CREA 203379/D - TO</p>
        </div>
      </div>
    </section>
  );
}

function Fotos({ e }) {
  const fotos = (e.relatorioFotografico || []).filter(f => f.url);

  if (!fotos.length) return null;

  const fotosPrimeiraPagina = 13;
  const fotosPorPagina = 9;
  const paginas = [];

  paginas.push(fotos.slice(0, fotosPrimeiraPagina));

  for (let i = fotosPrimeiraPagina; i < fotos.length; i += fotosPorPagina) {
    paginas.push(fotos.slice(i, i + fotosPorPagina));
  }

  return (
    <>
      {paginas.map((fotosPagina, paginaIndex) => (
        <div className="pagina fotos" key={`fotos-${paginaIndex}`}>
      <Cabecalho e={e} />
      <h2>RELATÓRIO FOTOGRÁFICO</h2>

          <div className={`grade-fotos ${paginaIndex === 0 ? "grade-fotos-destaque" : ""}`}>
            {fotosPagina.map((f, i) => {
              const numeroFoto = paginaIndex === 0
                ? i + 1
                : fotosPrimeiraPagina + (paginaIndex - 1) * fotosPorPagina + i + 1;

              return (
                <figure key={f.id || `${paginaIndex}-${i}`}>
                  <img src={f.url} alt={f.legenda} />
                  <figcaption>{f.legenda || `FOTO ${numeroFoto}`}</figcaption>
                </figure>
              );
            })}
      </div>

      <Rodape />
        </div>
      ))}
    </>
  );
}

function PaginaCapaCertificadoTracao({ e, certificado }) {
  return (
    <main className="pagina pagina-capa-certificado-tracao">
      <Cabecalho e={e} />

      <div className="titulo-certificado-tracao">
  ANEXO - Certificado de calibração - Célula de carga utilizada no ensaio.
</div>

<div className="info-certificado-tracao">
  <p>
    <b>Equipamento:</b>{" "}
    {certificado.equipamentoNome || certificado.equipamentoDescricao || "-"}
  </p>

  <p>
    <b>Certificado:</b>{" "}
    {certificado.numeroCertificado || certificado.nomeArquivoOriginal || "-"}
  </p>
</div>

      <Rodape />
    </main>
  );
}

function PaginasCertificadoTracao({ e, certificado }) {
  const [paginas, setPaginas] = useState([]);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    let ativo = true;

    async function carregar() {
      setPaginas([]);
      setErro(false);
      const blob = await getBlob(ref(storage, certificado.storagePathAtual));
      const pdf = await pdfjsLib.getDocument({ data: await blob.arrayBuffer() }).promise;
      const imagens = [];

      for (let numero = 1; numero <= pdf.numPages; numero += 1) {
        const pagina = await pdf.getPage(numero);
        const viewport = pagina.getViewport({ scale: 1.8 });
        const canvas = document.createElement("canvas");
        const contexto = canvas.getContext("2d");
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        await pagina.render({ canvasContext: contexto, viewport }).promise;
        imagens.push(canvas.toDataURL("image/jpeg", 0.92));
        pagina.cleanup();
      }

      await pdf.destroy();
      if (ativo) setPaginas(imagens);
    }

    carregar().catch(err => {
      console.error("Erro certificado:", err);
      if (ativo) setErro(true);
    });

    return () => {
      ativo = false;
    };
  }, [certificado.storagePathAtual]);

  if (erro) return <main className="pagina pagina-certificado-inline-tracao"><div>Não foi possível carregar o certificado.</div></main>;
  if (paginas.length === 0) return <main className="pagina pagina-certificado-inline-tracao"><div>Carregando certificado...</div></main>;

  return paginas.map((imagem, index) => (
    <main className="pagina pagina-certificado-inline-tracao" key={`${certificado.certificadoId || certificado.id}-${index}`}>
      <Cabecalho e={e} />
      <div className="titulo-certificado-inline-tracao">
        ANEXO: Certificado de calibração - Célula de carga
      </div>
      <div className="certificado-inline-box">
        <img src={imagem} alt={`Certificado de calibração - página ${index + 1}`} />
      </div>
    </main>
  ));
}
export default function RelatorioTracaoPrint({
  ensaio: e,
  certificado = null,
  onVoltar,
  autoPrint = false,
}) {
  const paginaResultadosRef = useRef(null);
  const observacoesRef = useRef(null);
  const [observacoesEmPaginaSeparada, setObservacoesEmPaginaSeparada] = useState(false);

  useEffect(() => {
    const tituloAnterior = document.title;
    document.title = String(e.codigo || tituloAnterior);
    return () => {
      document.title = tituloAnterior;
    };
  }, [e.codigo]);

  useEffect(() => {
    if (autoPrint) {
      window.setTimeout(() => {
        imprimirRelatorioTracao();
      }, 250);
    }
  }, [autoPrint]);

  const corpos = e.corposProva || [];
  const tipoEnsaio = normalizarTipoEnsaio(e.tipoEnsaio);
  const configuracao = CONFIGURACOES_POR_TIPO[tipoEnsaio];
  const placaQuadrada = usaPlacaQuadrada(tipoEnsaio);
  const tipoD = tipoEnsaio === "D";
  const textoAceitacao =
    tipoD && (e.textoAceitacao == null || e.textoAceitacao === ACEITACAO_PADRAO)
      ? ACEITACAO_TIPO_D
      : e.textoAceitacao ?? ACEITACAO_PADRAO;
  const temAceitacao = Boolean(String(textoAceitacao).trim());
  const tabelaAceitacao =
    tipoD &&
    (!Array.isArray(e.tabelaAceitacao) ||
      tabelaAceitacaoIgual(e.tabelaAceitacao, TABELA_ACEITACAO_PADRAO))
      ? TABELA_ACEITACAO_TIPO_D
      : Array.isArray(e.tabelaAceitacao)
      ? e.tabelaAceitacao
      : TABELA_ACEITACAO_PADRAO;

  const limiteResumo1Texto = e.limiteResumo1 ?? "0,20";
  const limiteResumo2Texto = e.limiteResumo2 ?? "0,30";
  const limiteResumo1 = numeroOuNulo(limiteResumo1Texto) ?? 0.2;
  const limiteResumo2 = numeroOuNulo(limiteResumo2Texto) ?? 0.3;
  const exibirResumoLimite1 =
    e.exibirResumoLimite1 ?? (e.exibirResumoLimites !== false);
  const exibirResumoLimite2 =
    e.exibirResumoLimite2 ?? (e.exibirResumoLimites !== false);
  const exibirResumoQuantidadeTipoD =
    e.exibirResumoQuantidadeTipoD ?? (e.exibirResumoTipoD !== false);
  const exibirCriterioResumoTipoD =
    e.exibirCriterioResumoTipoD ?? (e.exibirResumoTipoD !== false);

  useLayoutEffect(() => {
    if (!temAceitacao || observacoesEmPaginaSeparada) return undefined;

    const verificarEspaco = () => {
      const pagina = paginaResultadosRef.current;
      const observacoes = observacoesRef.current;
      if (!pagina || !observacoes) return;

      const paginaRect = pagina.getBoundingClientRect();
      const observacoesRect = observacoes.getBoundingClientRect();
      const pixelsPorMm = paginaRect.width / 210;
      const limiteConteudo = paginaRect.top + (281 * pixelsPorMm);

      if (observacoesRect.bottom > limiteConteudo) {
        setObservacoesEmPaginaSeparada(true);
      }
    };

    const frame = window.requestAnimationFrame(verificarEspaco);
    const observer = new ResizeObserver(verificarEspaco);
    if (paginaResultadosRef.current) observer.observe(paginaResultadosRef.current);
    if (observacoesRef.current) observer.observe(observacoesRef.current);

    return () => {
      window.cancelAnimationFrame(frame);
      observer.disconnect();
    };
  }, [temAceitacao, observacoesEmPaginaSeparada]);
  const acimaLimite1 = corpos.filter(
    x => (tensaoCalculada(x, e.tipoEnsaio) ?? 0) >= limiteResumo1
  ).length;
  const acimaLimite2 = corpos.filter(
    x => (tensaoCalculada(x, e.tipoEnsaio) ?? 0) >= limiteResumo2
  ).length;
  const acima030TipoD = corpos.filter(
    x => (tensaoCalculada(x, e.tipoEnsaio) ?? 0) >= 0.3
  ).length;
  return (
    <div className="relatorio-tracao">
      <div className="acoes">
        <button onClick={onVoltar}>Voltar</button>
        <button onClick={imprimirRelatorioTracao}>Imprimir</button>
      </div>

      <main className={`pagina pagina-1 ${!temAceitacao ? "sem-aceitacao" : ""}`}>
        <Cabecalho e={e} />

        <Secao numero="1" titulo="OBJETIVO DO ENSAIO">
          <p>
            Determinação da resistência de aderência à tração de revestimentos
            de argamassa aplicados em obra ou laboratório sobre substratos
            inorgânicos não metálicos.
          </p>
        </Secao>

        <Secao numero="2" titulo="DESCRIÇÃO DO SISTEMA DE REVESTIMENTO">
          <div className="sistema">
            <div>
              <b>Substrato</b>
              {Object.entries(opcoes.substrato).map(([k, v]) => (
                <Check
                  key={k}
                  ativo={(e.substrato || "estruturaConcreto") === k}
                  label={v}
                />
              ))}
            </div>

            <div>
              <b>Chapisco</b>
              <Check ativo={e.chapisco === "sim"} label="Sim" />
              <Check ativo={(e.chapisco || "nao") === "nao"} label="Não" />
            </div>

            <div>
              <b>Argamassa</b>
              {Object.entries(opcoes.argamassa).map(([k, v]) => (
                <Check
                  key={k}
                  ativo={(e.argamassa || "naoInformado") === k}
                  label={v}
                />
              ))}
            </div>

            <div>
              <b>Tipo de Aplicação</b>
              {Object.entries(opcoes.tipoAplicacao).map(([k, v]) => (
                <Check
                  key={k}
                  ativo={(e.tipoAplicacao || "naoInformado") === k}
                  label={v}
                />
              ))}
            </div>
          </div>
        </Secao>

        <Secao numero="3" titulo="METODOLOGIA">
          <TextoEmLinhas
            conteudo={e.textoMetodologia ?? configuracao.metodologia}
          />

          {!placaQuadrada && (
            <>
              <h3>3.1 Forma de ruptura dos corpos-de-prova</h3>

              <div className="forma-ruptura-imagem">
                <img
                  src="/Images/formaruptura.png"
                  alt="Formas de ruptura dos corpos de prova"
                />
              </div>
            </>
          )}
        </Secao>

        {temAceitacao && (
          <Secao numero="4" titulo="ACEITAÇÃO">
          <TextoEmLinhas conteudo={textoAceitacao} />

          <h3>Tabela 1 - Limites de resistência de aderência à tração (Ra)</h3>

          <table className="limites">
            <thead>
              <tr>
                <th>Local</th>
                <th>Acabamento</th>
                <th>Ra (MPa)</th>
              </tr>
            </thead>
            <tbody>
              {tabelaAceitacao.map((item, index) => (
                <tr key={index}>
                  <td>{item.local || "-"}</td>
                  <td>{item.acabamento || "-"}</td>
                  <td>{item.ra || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <small>
            {tipoD
              ? "Fonte ABNT NBR 13753:1996 - Item 5.11.7"
              : "Fonte ABNT NBR 13749 - Tabela 2"}
          </small>
          </Secao>
        )}

        {temAceitacao && <Rodape />}
      </main>

      <main
        ref={paginaResultadosRef}
        className={`pagina pagina-2 ${!temAceitacao ? "sem-aceitacao" : ""}`}
      >
        {temAceitacao && <Cabecalho e={e} />}

        <Secao numero={temAceitacao ? "5" : "4"} titulo="LOCALIZAÇÃO DOS ENSAIOS">
          <p className="destaque">{texto(e.localEnsaio)}</p>

          <div className="datas">
            <b>Data da colagem:</b> {dataBR(e.dataColagem)}{" "}
            <b>Data do Ensaio:</b> {dataBR(e.dataEnsaio)}{" "}
            <b>Idade do Revestimento:</b> {texto(e.idadeRevestimento)}
          </div>

          <h3>
            Quadro 1 - Resultados da determinação da resistência de aderência.
          </h3>

          <table className="resultados resultados-tracao-completa">
            <thead>
              <tr>
                <th colSpan={placaQuadrada ? 4 : 5}>Corpo de prova</th>
                <th colSpan="2">Local do ensaio</th>
                <th colSpan="7">Forma de Ruptura (%)</th>
                <th rowSpan="3">
                  Carga de
                  <br />
                  Ruptura
                  <br />
                  (kgf)
                </th>
                <th rowSpan="3">
                  Tensão
                  <br />
                  Ra
                  <br />
                  (MPa)
                </th>
              </tr>

              <tr>
                <th rowSpan="2">nº</th>
                <th colSpan={placaQuadrada ? 2 : 3}>
                  {placaQuadrada ? "Lado (mm)" : "Diâmetro (mm)"}
                </th>
                <th rowSpan="2">
                  Área
                  <br />
                  (mm²)
                </th>
                <th rowSpan="2">Bloco</th>
                <th rowSpan="2">Junta</th>

                {formasRuptura.map(f => (
                  <th key={f.key} rowSpan="2" className="forma-ruptura-cabecalho">
                    {f.label.split("/").map((parte, index) => (
                      <React.Fragment key={`${f.key}-${parte}`}>
                        {index > 0 && <br />}
                        {parte.trim()}
                      </React.Fragment>
                    ))}
                  </th>
                ))}
              </tr>

              <tr>
                <th>{placaQuadrada ? "L1" : "d1"}</th>
                <th>{placaQuadrada ? "L2" : "d2"}</th>
                {!placaQuadrada && <th>médio</th>}
              </tr>
            </thead>

            <tbody>
              {corpos.map((x, i) => (
                <tr key={i}>
                  <td>{valor(x.numero)}</td>
                  <td>{valor(x.d1)}</td>
                  <td>{valor(x.d2)}</td>
                  {!placaQuadrada && <td>{valor(x.diametroMedio)}</td>}
                  <td>
                    {placaQuadrada
                      ? decimal(areaCalculada(x, e.tipoEnsaio), 1)
                      : valor(x.area)}
                  </td>
                  <td>{x.local === "bloco" ? "✓" : "-"}</td>
                  <td>{x.local === "junta" ? "✓" : "-"}</td>

                  {formasRuptura.map(f => {
  const percentual = x.rupturasPercentuais?.[f.key];

  return (
    <td key={f.key}>
      {percentual === 0 || percentual === "0" || percentual
        ? valor(percentual)
        : "-"}
    </td>
  );
})}

                  <td>{valor(x.cargaRuptura)}</td>
                  <td>
                    <b>{decimal(tensaoCalculada(x, e.tipoEnsaio), 3)}</b>
                  </td>
                </tr>
              ))}
            </tbody>

            {(tipoD
              ? exibirResumoQuantidadeTipoD || exibirCriterioResumoTipoD
              : exibirResumoLimite1 || exibirResumoLimite2) && (
              <tfoot>
                {tipoD ? (
                  <>
                    {exibirResumoQuantidadeTipoD && (
                      <tr>
                        <td colSpan={placaQuadrada ? 13 : 14}>
                          {e.textoResumoQuantidadeTipoD ?? TEXTO_RESUMO_QUANTIDADE_TIPO_D_PADRAO}
                        </td>
                        <td colSpan="2">{acima030TipoD}</td>
                      </tr>
                    )}
                    {exibirCriterioResumoTipoD && (
                      <tr>
                        <td colSpan={placaQuadrada ? 15 : 16}>
                          {e.textoCriterioResumoTipoD ?? TEXTO_CRITERIO_RESUMO_TIPO_D_PADRAO}
                        </td>
                      </tr>
                    )}
                  </>
                ) : (
                  <>
                    {exibirResumoLimite1 && (
                      <tr>
                        <td colSpan={placaQuadrada ? 13 : 14}>
                          Valores acima de {String(limiteResumo1Texto).replace(".", ",")} MPa
                        </td>
                        <td colSpan="2">{acimaLimite1}</td>
                      </tr>
                    )}
                    {exibirResumoLimite2 && (
                      <tr>
                        <td colSpan={placaQuadrada ? 13 : 14}>
                          Valores acima de {String(limiteResumo2Texto).replace(".", ",")} MPa
                        </td>
                        <td colSpan="2">{acimaLimite2}</td>
                      </tr>
                    )}
                  </>
                )}
              </tfoot>
            )}
          </table>

          {temAceitacao && <QuadroUmidade e={e} />}
                </Secao>

        {temAceitacao && !observacoesEmPaginaSeparada && (
          <div ref={observacoesRef} className="bloco-observacoes-tracao">
            <Observacoes e={e} numero={6} />
          </div>
        )}

        <Rodape />
      </main>

      {temAceitacao && observacoesEmPaginaSeparada && (
        <main className="pagina pagina-observacoes-tracao">
          <Cabecalho e={e} />
          <Observacoes e={e} numero={6} />
          <Rodape />
        </main>
      )}

      {!temAceitacao && (
        <main className="pagina pagina-2 pagina-continuacao-tracao">
          <Cabecalho e={e} />
          <QuadroUmidade e={e} />
          <Observacoes e={e} numero={5} />
          <Rodape />
        </main>
      )}

      <Fotos e={e} />

{certificado?.storagePathAtual && (
  <PaginasCertificadoTracao e={e} certificado={certificado} />
)}
    </div>
  );
}
